var map = {
	"./en/account.json": 4493,
	"./en/admin.json": 8073,
	"./en/auth.json": 3468,
	"./en/breeds.json": 9265,
	"./en/common.json": 9279,
	"./en/events.json": 5555,
	"./en/landing.json": 2477,
	"./en/menu.json": 5125,
	"./en/onboarding.json": 1947,
	"./en/pets.json": 8008,
	"./en/registration.json": 2447,
	"./ru/account.json": 1923,
	"./ru/admin.json": 6779,
	"./ru/auth.json": 2326,
	"./ru/breeds.json": 8327,
	"./ru/common.json": 8057,
	"./ru/events.json": 3313,
	"./ru/landing.json": 247,
	"./ru/menu.json": 2347,
	"./ru/onboarding.json": 3585,
	"./ru/pets.json": 1886,
	"./ru/registration.json": 5361,
	"./sr/account.json": 8647,
	"./sr/admin.json": 3351,
	"./sr/auth.json": 5250,
	"./sr/breeds.json": 4251,
	"./sr/common.json": 9821,
	"./sr/events.json": 21,
	"./sr/landing.json": 4931,
	"./sr/menu.json": 5319,
	"./sr/onboarding.json": 4013,
	"./sr/pets.json": 986,
	"./sr/registration.json": 9661
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1803;
module.exports = webpackAsyncContext;